"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=CoursePublishEventMessage.js.map